
















































































































































































































































































































































































































































































































































































































































































































import { Vue, Component, Watch } from 'vue-property-decorator';
import { default as PageDescribe } from '@/components/PageDescribe.vue';
import { default as DataPanel } from '@/components/DataPanel.vue';
import { PaginationPanel, DraggerImg } from '@/components';
import collapse from '../../../utils/collapse.js';
import publicFunc from '../../../common/util/publicFunc';
import { CspInquiry, Inquiry, WayBill, yun,ExpenseType } from '@/http';
import { type } from '@/http/interface';
import { enums } from '@/common/enums';
import ListFilterPanel from '@/components/ListFilterPanel.vue';
import validator, { formRules } from '@/common/util/validator';
import { upload } from '@/common/util/ossUploadService';
import ElImageViewer from '@/components/imageviewer.vue';
export interface Pagination {
    skip: number;
    count: number;
    currentPage: number;
}
@Component({
    components: {
        PageDescribe,
        DataPanel,
        PaginationPanel,
        collapse,
        ListFilterPanel,
        ElImageViewer,
        DraggerImg,
    },
})
export default class WayBillManage extends Vue {
    public isDisabled: boolean = true;
    public publicFunc: any = publicFunc;
    public inquiryType = enums.inquiryType;
    public inquiryStatusType = enums.inquiryStatusType;
    public waybillStatusType = enums.wayBillStatusType;
    public ddStatusType = enums.ddState;
    public syncCarStatus = enums.syncCarStatus;
    public orderTypeList = enums.orderState
    public labelPosition: string = 'right';
    public formRules = formRules;
    public expandType: boolean = false;
    public loading = false;
    public rePagin = false;
    public tabelData = [];
    public total = 0;
    public isActive: boolean = false;
    timeList = [];
    public datetimerange(value) {
        if (value) {
            this.searchValue.creationStartTime = value[0];
            this.searchValue.creationEndTime = value[1];
        } else {
            this.searchValue.creationStartTime = null;
            this.searchValue.creationEndTime = null;
        }
    }
    statusArr: any = [];
    public searchValue: any = {
        carrierOrderStatus: '',//运单状态
        carrierOrderCode: '',//运单编号
        relatedCarrierOrderCode:'',//主运单编号
        orderCode: '',//订单编号
        orderId:'',//订单id
        subOrderNo:'',//子单编号
        shipOrderNo:'',//装运单号
        originShipOrderNo:'',//原装运单号
        deliveryOrderNo:'',//交货单号
        originAddress: '',//起始地
        arrivalAddress: '',//目的地
        carCode: '',  
        driverName:'',
        creationStartTime: '',
        creationEndTime: '',
        projectCode: '',
        primaryDeptName: '',
        receiptStatus:'',//回单状态
        customerBaseName:'',//发货方
        confirmDispatchMarkKind:'',//确认标识
        orderBy: '',
        syncCarStatus:'',
        orderType:''
    };
    public tableData: Array<type.CspInquiryListItem> = [];
    public searchPagin: Pagination = {
        skip: 0,
        count: 10,
        currentPage: 1,
    };
    public $refs: {
        pagination: HTMLFormElement;
        multipleTable: HTMLFormElement;
        glForm: HTMLFormElement;
        freeForm: HTMLFormElement;
    };
    public carrierOrderIdList: any = [];
    public timeList1: any = [];
    public ydbbdc3:boolean = false;//报表导出
    public yddw3:boolean = false;//运单定位
    public yffydj3:boolean = false;//应付费用登记
    public ysfydj3:boolean = false;//应收费用登记
    public szglyd3:boolean = false;//设置关联
    public ycdj3:boolean = false;//异常登记
    public zjyd3:boolean = false;//终结
    public created() {
        let webMenus = JSON.parse(localStorage.getItem('mlssloginAd')).webMenus;
        this.ydbbdc3 = webMenus.includes('ydbbdc3');
        this.yddw3 = webMenus.includes('yddw3');
        this.yffydj3 = webMenus.includes('yffydj3');
        this.ysfydj3 = webMenus.includes('ysfydj3');
        this.szglyd3 = webMenus.includes('szglyd3');
        this.ycdj3 = webMenus.includes('ycdj3');
        this.zjyd3 = webMenus.includes('zjyd3');
        console.log('res===>',this.ydbbdc3,this.yddw3,this.yffydj3);
        
    }
    public mounted() {
        if (sessionStorage.getItem('qydwaybill_searchValue') && this.$route.query.form != 'DataAnalysis') {
            this.searchValue = JSON.parse(sessionStorage.getItem('qydwaybill_searchValue'));
            this.timeList = [this.searchValue.creationStartTime, this.searchValue.creationEndTime];
            if (this.searchValue.carrierOrderStatus) {
                this.statusArr = this.searchValue.carrierOrderStatus.split(',');
            }

            this.searchPagin = sessionStorage.getItem('qydwaybill_page') ? JSON.parse(sessionStorage.getItem('qydwaybill_page')) : this.searchPagin;
            this.getInquiryList();
        } else if (!sessionStorage.getItem('qydwaybill_searchValue') && this.$route.query.form != 'DataAnalysis') {
            this.searchPagin = sessionStorage.getItem('qydwaybill_page') ? JSON.parse(sessionStorage.getItem('qydwaybill_page')) : this.searchPagin;
            this.getInquiryList();
        } else if (this.$route.query.form == 'DataAnalysis') {
            let temp: any = this.$route.query.carrierOrderIdList;
            this.carrierOrderIdList = JSON.parse(temp);
            this.searchValue.arrivalAddress = this.$route.query.arrivalProvinceStr;
            this.searchValue.originAddress = this.$route.query.originProvinceStr;
            this.statusArr = ['2','3'];
            this.timeList1 = [this.$route.query.realDeliveryStartTimestr, this.$route.query.realDeliveryEndTimestr];
            this.searchValue.realDeliveryStartTime = this.timeList1[0];
            this.searchValue.realDeliveryEndTime = this.timeList1[1];
            this.getInquiryList();
        }
    }

    public gilist:any = [];
    async querySearchglyd(queryString,cb){
        let res = await WayBill.getRelated({relatedCarrierOrderCode:this.addgl.glCode,relatedShipOrderNo:''});
        console.log(res);
        let result = [];
        res.forEach((dd) => {
            let xx = {
                value: dd.carrierOrderCode+'/'+dd.shipOrderNo,
                id: dd.id,
                //shipOrderNo:dd.ShipOrderNo
            };
            result.push(xx);
        });        
        this.gilist = result;
        cb(result);
    }
    selectglyd(data){
        let arr = data.value.split('/');
        this.addgl.id = data.id;
        this.addgl.glCode = arr[0];        
        this.addgl.glZyCode = arr[1];
    }
    glydclear(){
        this.addgl.glCode = '';
        this.addgl.id = '';
    }
    async querySearchglzydh(queryString,cb){
        let res = await WayBill.getRelated({relatedCarrierOrderCode:'',relatedShipOrderNo:this.addgl.glZyCode});
        console.log(res);
        let result = [];
        res.forEach((dd) => {
            let xx = {
                //carrierOrderCode: dd.ShipOrderNo+'/'+dd.carrierOrderCode,
                id: dd.id,
                value:dd.shipOrderNo+'/'+dd.carrierOrderCode,
            };
            result.push(xx);
        });        
        cb(result);
    }
    selectglzydh(data){
        let arr = data.value.split('/');
        this.addgl.glCode = arr[1];
        this.addgl.id = data.id;
        this.addgl.glZyCode = arr[0];
    }
    glzyclear(){
        this.addgl.glZyCode = '';
        this.addgl.id = '';
    }

    addexpectDialog: boolean = false;
    addexpect: any = {
        code: '',
        type: '',
        description: '',
        reason: '',
        pics: [],
        customerComplaintWeight:'',
        customerComplaintPrice:'',
        customerComplaintCutPayment:''
    };
    addfreeDialog: boolean = false;
    addfree: any = {
        jjfs: '线路-车长', //计价方式
        danj: '', //单价
        count: 1, //数量
        dw: '3', //数量单位
        feeType: '', //费用类型
        feeAmount: '', //费用金额
        feeExplain: '', //费用说明
        carrierOrderCode: '',
    };
    addglDialog: boolean = false;
    addgl:any={
        id:'',//关联id
        carrierOrderCode:'',//运单编号
        zxCode:'',//装运单号
        glCode:'',//关联运单号
        glZyCode:''//关联装运单号
    }
    calAmount() {
        this.addfree.feeAmount = this.addfree.danj * this.addfree.count;
    }
    clickGl() {
        if (this.selectionRow.length != 0) {
            let row = this.selectionRow[0];

            // if (row.carrierOrderStatus != 1 && row.carrierOrderStatus != 2 && row.carrierOrderStatus != 3) {
            //     return this.$message.warning('只有待发货、在途中、已送达的运单可添加费用!');
            // }
            //this.GetfeeTypeList();
            this.addgl.carrierOrderCode = '';
            this.addgl.zxCode = '';
            this.addgl.glCode = '';
            this.addgl.glZyCode = '';            
            this.addgl.carrierOrderCode = this.selectionRow[0].carrierOrderCode;            
            this.addgl.zxCode = this.selectionRow[0].orderList[0].shipOrderNo;
            console.log('select--row', row);                       
            this.addglDialog = true;
            this.$refs['glForm'].resetFields();
        } else {
            this.$message.warning('请先选中一条数据');
        }        
    }
     toaddGl() {
        this.$refs['glForm']['validate']((valid) => {
            if (valid) {
                let row = this.selectionRow[0];
                console.log('关联运单号-->',this.addgl);                
                WayBill.setRelation({
                    id: row.id,
                    relatedCarrierOrderId: this.addgl.id                    
                }).then((res) => {
                    this.addglDialog = false;
                    this.$message.warning('关联运单成功!');
                    this.getInquiryList();
                });
                console.log('goto 新增关联');
            }
        });
    }
    /**
     * 获取费用类型
     */
    public feeTypeList = [];
    public async GetfeeTypeList() {
        await ExpenseType.GetList({
            isEnable: true,
            skip: -1,
            count: -1,
        }).then((res) => {
            this.feeTypeList = res.data;
            console.log('费用类型-->',res);
        });
    }
    type:any = '';
    title:any = '';
    clickAddFree(type) {
        this.type = type;
        if (this.selectionRow.length != 0) {
            let row = this.selectionRow[0];

            // if (row.carrierOrderStatus != 2) {
            //     if(type == 'a'){
            //         return this.$message.warning('只有在途中的运单可添加应付费用!');
            //     }else{
            //         return this.$message.warning('只有在途中的运单可添加应收费用!');
            //     }
                
            // }
            this.GetfeeTypeList();            
            this.addfree.danj = '';
            this.addfree.count = '';
            this.addfree.feeType = '';
            this.addfree.feeAmount = '';
            this.addfree.feeExplain = '';
            this.addfree.carrierOrderCode = this.selectionRow[0].carrierOrderCode;
            console.log('select--row', row);
            // PriceList.GetxlyPrice({
            //     priceListType: 1,
            //     deliveryProvince: row.orderList[0].originProvince,
            //     deliveryCity: row.orderList[0].originCity,
            //     deliveryArea: row.orderList[0].originCounty,
            //     arrivalProvince: row.orderList[0].arrivalProvince,
            //     arrivalCity: row.orderList[0].arrivalCity,
            //     arrivalArea: row.orderList[0].arrivalCounty,
            //     titleName: row.carLengthEnumStr ? row.carLengthEnumStr : row.vehicleTypeEnumStr,
            // }).then((res) => {
            //     console.log('getprice', res);
            //     this.addfree.danj = res.extData;
            //     //this.addfree.danj = 100;
            //     if (this.addfree.danj) {
            //         this.addfree.count = 1;
            //     }
            //     this.addfreeDialog = true;
            //     this.$refs['freeForm'].resetFields();
            // });            
            if(this.type == 'a'){
                this.title='新增应付费用';
            }else{
                this.title='新增应收费用';
            }
            this.addfreeDialog = true;            
            this.$refs['freeForm'].resetFields();
        } else {
            this.$message.warning('请先选中一条数据');
        }        
    }
    toaddfree() {
        this.$refs['freeForm']['validate']((valid) => {
            if (valid) {
                let row = this.selectionRow[0];
                if(this.type == 'a'){
                    WayBill.addYf({
                        carrierOrderId: row.id,
                        feeType: this.addfree.feeType,
                        feeAmount: this.addfree.feeAmount,
                        feeExplain: this.addfree.feeExplain,
                    }).then(res=>{
                        this.addfreeDialog = false;
                        this.$message.warning('应付费用新增成功!');
                    })
                }else{
                    WayBill.addYs({
                        carrierOrderId: row.id,
                        expenseType: this.addfree.feeType,
                        amount: this.addfree.feeAmount,
                        expenseExplain: this.addfree.feeExplain,
                    }).then(res=>{
                        this.addfreeDialog = false;
                        this.$message.warning('应收费用新增成功!');
                    })
                }               
                console.log('goto 新增费用');
            }
        });
    }
    public feeTypes = [];
    clickAddExcept() {
        if (this.selectionRow.length != 0) {
            this.addexpectDialog = true;
            let row = this.selectionRow[0];
            this.addexpect.code = row.carrierOrderCode;
            this.addexpect.type = '';
            this.addexpect.description = '';
            this.addexpect.reason = '';
            this.addexpect.pics = [];
            this.addexpect.customerComplaintPrice = 5;
            this.addexpect.customerComplaintCutPayment = '';
            this.addexpect.customerComplaintWeight = '';
            Inquiry.GetDicDetailList({ typeName: 'anomalyType' }).then((res) => {
                this.feeTypes = res.map((v) => {
                    return { id: v.id, name: v.name, value: v.value };
                });
                (this.$refs['expectForm'] as any).resetFields();
            });
            console.log('select--row', row);
        } else {
            this.$message.warning('请先选中一条数据');
        }
    }
    weightChange(e,number){
        if(number){
            e.target.value= e.target.value.match(/\d{1,9}(\.\d{0,4})?/) ? e.target.value.match(/\d{1,9}(\.\d{0,4})?/)[0] : ''
            this.addexpect.customerComplaintWeight = e.target.value;
        }else{
            this.addexpect.customerComplaintWeight = e.target.value;
        }
        if(this.addexpect.customerComplaintWeight != ''&& this.addexpect.customerComplaintWeight != null && this.addexpect.customerComplaintWeight != undefined && this.addexpect.customerComplaintPrice != ''&& this.addexpect.customerComplaintPrice != null && this.addexpect.customerComplaintPrice != undefined){
            let total = this.addexpect.customerComplaintWeight*this.addexpect.customerComplaintPrice;
            total.toString().replace(/[^-\d^\.]+/g,'');
             if(!isNaN(total)){
                this.addexpect.customerComplaintCutPayment =total.toString().replace(/^(\-)*(\d+)\.(\d\d).*$/, "$1$2.$3");
             }else{
                this.addexpect.customerComplaintCutPayment = '';
             }
            
            //this.addexpect.customerComplaintCutPayment = total.toString().match(/\d{1,9}(\.\d{0,2})?/) ? total.toString().match(/\d{1,9}(\.\d{0,2})?/)[0] : ''
        }
    }
    priceChange(e,number){
        if(number){
            // e.target.value= e.target.value.match(/(-)?\d{1,9}(\.\d{0,2})?/) ? e.target.value.match(/(-)?\d{1,9}(\.\d{0,2})?/)[0] : ''
            // this.addexpect.customerComplaintPrice = e.target.value;
            e.target.value =e.target.value.replace(/[^-\d^\.]+/g,'');
            this.addexpect.customerComplaintPrice = e.target.value.replace(/^(\-)*(\d+)\.(\d\d).*$/, "$1$2.$3");
        }else{
            this.addexpect.customerComplaintPrice = e.target.value;
        }
        if(this.addexpect.customerComplaintWeight != ''&& this.addexpect.customerComplaintWeight != null && this.addexpect.customerComplaintWeight != undefined && this.addexpect.customerComplaintPrice != ''&& this.addexpect.customerComplaintPrice != null && this.addexpect.customerComplaintPrice != undefined){            
            let total = this.addexpect.customerComplaintWeight*this.addexpect.customerComplaintPrice;
            total.toString().replace(/[^-\d^\.]+/g,'');
            if(!isNaN(total)){
                this.addexpect.customerComplaintCutPayment =total.toString().replace(/^(\-)*(\d+)\.(\d\d).*$/, "$1$2.$3");
            }else{
                this.addexpect.customerComplaintCutPayment = ''
            }
            
            //this.addexpect.customerComplaintCutPayment=total.toString().match(/(-)?\d{1,9}(\.\d{0,2})?/) ? total.toString().match(/(-)?\d{1,9}(\.\d{0,2})?/)[0] : ''
        }
    }
    ksChange(e,number){
        if(number){
            // e.target.value= e.target.value.match(/(-)?\d{1,9}(\.\d{0,2})?/) ? e.target.value.match(/(-)?\d{1,9}(\.\d{0,2})?/)[0] : ''
            // this.addexpect.customerComplaintCutPayment = e.target.value;
            e.target.value =e.target.value.replace(/[^-\d^\.]+/g,'');
            this.addexpect.customerComplaintCutPayment = e.target.value.replace(/^(\-)*(\d+)\.(\d\d).*$/, "$1$2.$3");
        }else{
            this.addexpect.customerComplaintCutPayment = e.target.value;
        }
    }
    toaddexcept() {
        this.$refs['expectForm']['validate']((valid) => {
            if (valid) {
                let row = this.selectionRow[0];
                let anomalyTypeStr = this.feeTypes.filter((v) => {
                    if (v.id == this.addexpect.type) {
                        return v;
                    }
                });
                console.log('value-->', anomalyTypeStr);
                let carrierAttList = this.addexpect.pics.map((v) => {
                    return { name: v.name, url: v.url };
                });
                WayBill.addException({
                    // carrierId: row.carrierId,
                    // carrierName: row.carrierName,
                    carrierOrderId: row.id,
                    //carrierOrderCode: row.carrierOrderCode,
                    anomalyTypeEnum: anomalyTypeStr[0].value,
                    anomalyTypeStr: anomalyTypeStr[0].name,
                    description: this.addexpect.description,
                    cause: this.addexpect.reason,
                    anomalyPictures: carrierAttList,
                    // primaryDeptName: row.orderList[0].primaryDeptName,
                    // primaryDeptId: row.orderList[0].primaryDeptId,
                    // carCode: row.carCode,
                    customerComplaintWeight:this.addexpect.customerComplaintWeight,
                    customerComplaintPrice:this.addexpect.customerComplaintPrice,
                    customerComplaintCutPayment:this.addexpect.customerComplaintCutPayment
                }).then(() => {
                    this.addexpectDialog = false;
                    this.$message.warning('异常登记成功!');
                });
                this.addexpectDialog = false;
                console.log('goto 异常登记');
            }
        });
    }
    public feeAmountDisabled = false;
    changeFree(val) {
        console.log('changefreeType', val);
        // if (this.addfree.danj) {
        //     if (val === '运费') {
        //         this.feeAmountDisabled = true;
        //         this.calAmount();
        //     } else {
        //         this.feeAmountDisabled = false;
        //         this.addfree.feeAmount = '';
        //     }
        // }
    }
    public sort(col): void {
        if (col.order == 'ascending') {
            this.searchValue.asc = true;
        } else {
            this.searchValue.asc = false;
        }
        switch (col.prop) {
            case 'projectCode':
                {
                    this.searchValue.orderBy = '1';
                }
                break;
            case 'consignee':
                {
                    this.searchValue.orderBy = '1';
                }
                break;
            case 'carriageWayStr':
                {
                    this.searchValue.orderBy = '3';
                }
                break;
            case 'realDeliveryTime':
                {
                    this.searchValue.orderBy = '2';
                }
                break;
            case 'realArrivalTime':
                {
                    this.searchValue.orderBy = '3';
                }
                break;
            case 'carLengthEnumStr':
                {
                    this.searchValue.orderBy = '4';
                }
                break;
            case 'carrierOrderStatus':
                {
                    this.searchValue.orderBy = '5';
                }
                break;
            case 'creationTime':
                {
                    this.searchValue.orderBy = '6';
                }
                break;
        }
        this.getInquiryList();
    }

    public toOrder(data) {}

    public toEdit(data) {
        this.$router.push({
            path: '/AddInquiry',
            query: {
                id: data.id,
                type: 'edit',
            },
        });
    }

    dialogImageUrl = '';
    dialogImage: any = false;
    public handlePreview(file) {
        this.dialogImageUrl = file.url;
        this.dialogImage = true;
    }
    public onClose() {
        this.dialogImage = false;
    }

    public getMore() {
        this.expandType = !this.expandType;
    }

    public async exportExcel() {
        this.searchValue.carrierOrderStatus = this.statusArr.join();
        //let data = await WayBill.Export(this.searchValue);
        // if (data) {
        //     window.open(data.attachmentUrl);
        // } else {
        //    this.$message.warning('导出失败!');
        // }
        if (this.$route.query.form == 'DataAnalysis') {
            let data = await WayBill.Export({
                carrierOrderIdList: this.carrierOrderIdList,
                ...this.searchValue,
            });
        } else {
            let data = await WayBill.Export({
                ...this.searchValue,
            });
        }
    }

    public getInquiryList() {
        this.loading = true;
        this.searchValue.carrierOrderStatus = this.statusArr.join();
        let carrierOrderIdList = null;
        if (this.$route.query.form == 'DataAnalysis') {
            carrierOrderIdList = JSON.parse(JSON.stringify(this.carrierOrderIdList));
            console.log('from-->', this.carrierOrderIdList, carrierOrderIdList);
        }
        WayBill.getList({
            ...this.searchValue,
            carrierOrderIdList: carrierOrderIdList,
            skip: this.searchPagin.skip,
            count: this.searchPagin.count,
        })
            .then((res) => {
                this.tableData = res.data;
                let skip = this.searchPagin.skip;
                this.$refs.pagination.setNowPage(this.searchPagin.count);
                this.$refs.pagination.setPage(this.searchPagin.currentPage);
                this.tableData.map((item, index) => {
                    item.index = skip++ + 1;
                });
                this.total = res.total;
                this.loading = false;
                this.$refs.pagination.setPage(this.searchPagin.currentPage);
            })
            .catch((err) => {
                this.loading = false;
            });
    }
    public searchFunc() {
        this.searchValue.carrierOrderStatus = this.statusArr.join();
        sessionStorage.setItem('qydwaybill_searchValue', JSON.stringify(this.searchValue));
        this.$refs.pagination.handleCurrentChange(1);
        this.searchPagin.skip = 0;
    }

    public async onPaginationChange(pagin: Pagination) {
        this.searchPagin = pagin;
        sessionStorage.setItem('qydwaybill_page', JSON.stringify(pagin));
        this.getInquiryList();
    }

    public viewInquiry(item) {
        sessionStorage.setItem('qydwaybill_page', JSON.stringify(this.searchPagin));
        this.$router.push({
            path: '/InquiryDetail',
            query: {
                type: 'view',
                id: item.id,
            },
        });
    }
    public selectionRow = [] as any;
    public multipleSelection: any;
    public yfkfyCheckDiabled:any = true;//应付费用登记
    public ysfyCheckDiabled:any = true;//应收费用登记
    public szglDiabled:any = true;//设置关联
    public dwDisabled:any = true;//定位
    public ycdjDisabled:any = true;//异常登记
    handleSelectionChange(rows) {
        this.selectionRow = rows;
        if(rows && rows.length>=1){
            this.ycdjDisabled = false;
            this.dwDisabled = false;
            if(rows[0].carrierOrderStatus==1 || rows[0].carrierOrderStatus==2 || rows[0].carrierOrderStatus==3){
                this.yfkfyCheckDiabled = false
                this.ysfyCheckDiabled = false
            }else{
                this.yfkfyCheckDiabled = true
                this.ysfyCheckDiabled = true
            }
            if(rows[0].carrierOrderStatus!=4){
                this.szglDiabled = false
            }else{
                this.szglDiabled = true
            }
        }else{
            this.ycdjDisabled = true;
            this.dwDisabled = true;
            //配车按钮
            this.yfkfyCheckDiabled = true;
            this.ysfyCheckDiabled = true;
            this.szglDiabled = true;
        }
        if (rows.length > 1) {
            this.$refs.multipleTable.clearSelection();
            this.$refs.multipleTable.toggleRowSelection(rows.pop());
        }
    }
    /** 单选配置 */
    /* start */
    rowClick(row) {
        let refsElTable = this.$refs.multipleTable as any; // 获取表格对象
        let findRow = this.selectionRow.find((c) => c.rowIndex == row.rowIndex);
        if (findRow) {
            refsElTable.toggleRowSelection(row, false);
            return;
        }
        refsElTable.clearSelection();
        refsElTable.toggleRowSelection(row); // 调用选中行方法
    }

    rowStyle({ row, rowIndex }) {
        Object.defineProperty(row, 'rowIndex', {
            //给每一行添加不可枚举属性rowIndex来标识当前行
            value: rowIndex,
            writable: true,
            enumerable: false,
        });
    }
    selectable(row, rowIndex) {
        //多选框不可勾选
        if (this.selectionRow.find((c) => c.rowIndex === row.rowIndex)) {
            return true;
        } else {
            return false;
        }
    }
    toDetail(row, type, index) {
        let bd = row.orderList.length > 1 ? true : false;
        if (type == 1) {
            this.$router.push({
                path: '/WayBillDetail',
                query: {
                    //id: row.id,
                    id: row.orderList[0].id,
                    name: 'detail',
                    orderCnt: row.orderList.length,
                    //orderId:row.orderList[0].id
                    orderId: row.id,
                    tab: 'second',
                    status: row.carrierOrderStatus,
                    carCode: row.carCode,
                    deliveryAddress: row.orderList[0].originAddress,
                    arrivalAddress: row.orderList[0].arrivalAddress,
                    driverPhone: row.orderList[0].driverPhone,
                },
            });
        } else if (type == 2) {
            this.$router.push({
                path: '/orderDetailcc',
                query: {
                    id: row.orderList[index].id,
                    name: 'detail',
                    //orderCnt:row.orderList.length,
                    //orderId:row.orderList[0].id
                    from: 'WayBillManage',
                    status: row.carrierOrderStatus,
                    carCode: row.carCode,
                    deliveryAddress: row.orderList[0].originAddress,
                    arrivalAddress: row.orderList[0].arrivalAddress,
                    driverPhone: row.orderList[0].driverPhone,
                },
            });
        } else if (type == 3) {
            this.$router.push({
                path: '/WayBillDetail',
                query: {
                    //id: row.id,
                    id: row.orderList[0].id,
                    name: 'detail',
                    orderCnt: row.orderList.length,
                    //orderId:row.orderList[0].id
                    orderId: row.id,
                    tab: 'third',
                },
            });
        }
    }
    toDetail1(){
        this.$router.push({
                path: '/WayBillDetail',
                query: {
                    //id: row.id,
                    id: this.selectionRow[0].orderList[0].id,
                    name: 'detail',
                    orderCnt: this.selectionRow[0].orderList.length,
                    //orderId:row.orderList[0].id
                    orderId: this.selectionRow[0].id,
                    tab: 'second',
                },
            });
    }
    copAdd() {
        if (this.selectionRow.length != 0) {
            console.log('ddddd->', this.selectionRow);
            this.$router.push({
                path: '/WayBillLocation',
                query: {
                    //type: 'copy',
                    id: this.selectionRow[0].id,
                    carCode: this.selectionRow[0].carCode,
                    deliveryAddress: this.selectionRow[0].orderList[0].originAddress,
                    arrivalAddress: this.selectionRow[0].orderList[0].arrivalAddress,
                    driverPhone: this.selectionRow[0].driverPhone,
                },
            });
        } else {
            this.$alert('请先选中一条数据');
        }
    }

    public handleDelete(data) {
        this.$confirm('确认删除该询价单?', '询价单删除', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
        })
            .then(() => {
                Inquiry.DelInquiry(data).then(() => {
                    this.$message.success('询价单删除成功');
                    this.getInquiryList();
                });
            })
            .catch(() => {});
    }
    public handleFinal(data) {
        this.$confirm('确认终结该询价单?', '询价单终结', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
        })
            .then(() => {
                Inquiry.EndInquiry(data).then(() => {
                    this.$message.success('询价单终结成功');
                    this.getInquiryList();
                });
            })
            .catch(() => {});
    }

    public handleCommand(command) {
        switch (command.command) {
            case 'delete':
                this.handleDelete(command.data);
                break;
            case 'final':
                this.handleFinal(command.data);
                break;
        }
    }

    beforeHandleCommand(data, command) {
        return {
            data: data,
            command: command,
        };
    }

    public colData =
        JSON.parse(localStorage.getItem('qydwaybill')) && JSON.parse(localStorage.getItem('qydwaybill')).length == 21
            ? JSON.parse(localStorage.getItem('qydwaybill'))
            : [
                { title: '运单状态', isShow: true, disabled: false },
                { title: '运单编号', isShow: true, disabled: false },
                { title: '装运单号', isShow: true, disabled: false },
                { title: '客户/基地名称', isShow: true, disabled: false },
                { title: '收货方', isShow: true, disabled: false },
                { title: '收货地址', isShow: true, disabled: false },
                { title: '车队名称', isShow: true, disabled: false },
                { title: '车牌号', isShow: true, disabled: false },
                { title: '司机', isShow: true, disabled: false },
                { title: '计划进场时间', isShow: true, disabled: false },
                { title: '发货时间', isShow: true, disabled: false },
                { title: '送达时间', isShow: true, disabled: false },
                { title: '实际发货重量', isShow: true, disabled: false },
                { title: '下单时间', isShow: true, disabled: false },
                { title: '配车同步状态', isShow: true, disabled: false },
                { title: '确认调度标识', isShow: true, disabled: false },
                { title: '主运单编号', isShow: true, disabled: false },
                { title: '计划编号', isShow: true, disabled: false },
                { title: '子单号', isShow: true, disabled: false },
                { title: '原装运单号', isShow: true, disabled: false },
                { title: '交货单号', isShow: true, disabled: false },
                { title: '发货地址', isShow: true, disabled: false },
              ];
    public handleCheckedChange() {
        let newDate = this.colData.filter((item) => item.isShow == false);
        if (this.colData.length - newDate.length == 3) {
            this.$message.warning('至少选择3个');
            this.colData.forEach((item) => {
                if (item.isShow) {
                    item.disabled = true;
                }
            });
        } else {
            this.colData.forEach((item) => {
                item.disabled = false;
            });
        }
        localStorage.setItem('qydwaybill', JSON.stringify(this.colData));
    }

    public resetSearchValue() {
        this.searchValue = {
           carrierOrderStatus: '',//运单状态
            carrierOrderCode: '',//运单编号
            relatedCarrierOrderCode:'',//主运单编号
            orderCode: '',//订单编号
            orderId:'',//订单id
            subOrderNo:'',//子单编号
            shipOrderNo:'',//装运单号
            originShipOrderNo:'',//原装运单号
            deliveryOrderNo:'',//交货单号
            originAddress: '',//起始地
            arrivalAddress: '',//目的地
            carCode: '',  
            carrierName:'',
            creationStartTime: '',
            creationEndTime: '',
            projectCode: '',
            primaryDeptName: '',
            receiptStatus:'',//回单状态
            customerBaseName:'',//发货方
            confirmDispatchMarkKind:'',//确认标识
            orderBy: '',
            syncCarStatus:'',
            orderType:''
        };
        this.carrierOrderIdList = [];
        this.statusArr = [];
        this.timeList = [];
        this.searchFunc();
    }

    // querySearchStartAsync方法 所用到的组件 于 9762d58fdf9f0dbfb5d3d9be2b08db6aba50e32d 被注释 该方法无用 先去掉

    public handlStarteSelect(item) {
        // this.startPlaceLongitude = item.point.lng;
        // this.startPlaceLatitude = item.point.lat;
        console.log('handleselect-->', item);
    }
    selectList: any = [];
    async querySearchcys(queryString, cb) {
        this.searchValue.carrierId = '';
        let res = await yun.GetCarrierList({ Name: this.searchValue.carrierName });
        console.log(res.data);
        let result = [];
        res.data.forEach((dd) => {
            let xx = {
                value: dd.name,
                id: dd.id,
            };
            result.push(xx);
        });
        this.selectList = result;
        cb(result);
    }
    selectCys(data) {
        this.searchValue.carrierId = data.id;
    }
    public isSend: boolean = false;
    public async handleUpload(param, file, fileList) {
        if(!this.isSend){
        const loading = this.$loading({
                lock: true,
                text: 'Loading...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)',
            });           
        console.log('toupload-->', param);
        const res = await upload(param.file, param.file.name);
        if (res.res.statusCode == '200') {
            let url = res.res.requestUrls[0].split('?')[0];
            console.log('chengggonel-->', param.file.name, url);
            this.addexpect.pics.push({ name: param.file.name, url: url });
            loading.close();
        } else {
            this.$message.warning('图片上传失败!');
        }
        // const loading = this.$loading({
        //     lock: true,
        //     text: 'Loading...',
        //     spinner: 'el-icon-loading',
        //     background: 'rgba(0, 0, 0, 0.7)'
        // });
        // let ff = window.URL.createObjectURL(param.file)
        // console.log('toupload-7777->', param,fileList,this.bgcl.carrierAttList,ff);
        // let reader = new FileReader();
        // reader.readAsArrayBuffer(param.file);
        // reader.onload = ()=>{
        //     console.log('enter');
        //     let blob = new Blob([reader.result]);
        //     let formdata = new FormData();
        //     formdata.append('fileList',blob,param.file.name);
        //     WayBill.fileUpload(formdata).then(res=>{
        //         if (res.ss) {
        //             this.$alert(res.error)
        //             if (this.addexpect.pics.length > 0) {
        //                 this.addexpect.pics.splice(this.addexpect.pics.length - 1,1,this.addexpect.pics[this.addexpect.pics.length - 1])
        //             } else {
        //                 this.addexpect.pics = []
        //             }
        //             loading.close();
        //         } else {
        //             console.log('upload-->',res,fileList,res.extData);
        //             this.addexpect.pics.push({ name: param.file.name, url:ff ,path: res.extData[0]});
        //             loading.close();
        //         }
        //     });
        // }
        }
    }
    public beforeAvatarUpload(file) {
        let imgType = file.name.split('.').pop();
        let allowType = ['jpg', 'jpeg', 'png', 'gif', 'tiff'];
        //console.log('type-->',file,imgType);
        if (allowType.indexOf(imgType.toLowerCase()) === -1) {
            this.$alert('不支持该文件类型').then((e) => {});
            return false;
        }
        if (file.size / 1024 / 1024 > 50) {
            this.$alert('不能上传超过50M').then((e) => {});
            return false;
        }
    }
    handleRemove(file, fileList) {
        if (this.addexpect.pics.includes(file)) {
            this.addexpect.pics.splice(this.addexpect.pics.indexOf(file), 1);
        }
        console.log(file, fileList);
    }
    public onexceed() {
        this.$message.warning('最多上传20张!');
    }
    flexColumnWidth(str, tableData, flag = 'max') {
        // str为该列的字段名(传字符串);tableData为该表格的数据源(传变量);
        // flag为可选值，可不传该参数,传参时可选'max'或'equal',默认为'max'
        // flag为'max'则设置列宽适配该列中最长的内容,flag为'equal'则设置列宽适配该列中第一行内容的长度。
        str = str + '';
        let columnContent = '';
        if (!tableData || !tableData.length || tableData.length === 0 || tableData === undefined) {
            return '140px';
        }
        if (!str || !str.length || str.length === 0 || str === undefined) {
            return '150px';
        }
        if (flag === 'equal') {
            // 获取该列中第一个不为空的数据(内容)
            for (let i = 0; i < tableData.length; i++) {
                if (tableData[i][str].length > 0) {
                    // console.log('该列数据[0]:', tableData[0][str])
                    columnContent = tableData[i][str];
                    break;
                }
            }
        } else {
            // 获取该列中最长的数据(内容)
            if (
                str == 'projectName' ||
                str == 'arrivalAddress' ||
                str == 'noticeCode' ||
                str == 'projectCode1' ||
                str == 'consigneePhone' ||
                str == 'originAddress' ||
                str == 'subOrderNo' ||
                str == 'shipOrderNo' ||
                str == 'deliveryOrderNoes' ||
                str == 'consigneeName'
            ) {
                let index = 0;
                let index1 = 0;
                for (let i = 0; i < tableData.length; i++) {
                    for (let j = 0; j < tableData[i]['orderList'].length; j++) {
                        if (tableData[i]['orderList'][j][str] === null) {
                            return;
                        }
                        const now_temp = tableData[i]['orderList'][j][str] + '';
                        const max_temp = tableData[index]['orderList'][index1][str] + '';
                        if (now_temp.length > max_temp.length) {
                            index = i;
                            index1 = j;
                        }
                        columnContent = tableData[index]['orderList'][index1][str];
                    }
                }
            } else {
                let index = 0;
                for (let i = 0; i < tableData.length; i++) {
                    if (tableData[i][str] === null) {
                        return;
                    }
                    const now_temp = tableData[i][str] + '';
                    const max_temp = tableData[index][str] + '';
                    if (now_temp.length > max_temp.length) {
                        index = i;
                    }
                }
                columnContent = tableData[index][str];
            }
        }
        // console.log('该列数据[i]:', columnContent)
        // 以下分配的单位长度可根据实际需求进行调整
        let flexWidth = 0;
        for (const char of columnContent) {
            if ((char >= 'A' && char <= 'Z') || (char >= 'a' && char <= 'z')) {
                // 如果是英文字符，为字符分配8个单位宽度
                flexWidth += 9;
            } else if (char >= '\u4e00' && char <= '\u9fa5') {
                // 如果是中文字符，为字符分配15个单位宽度
                flexWidth += 14;
            } else {
                // 其他种类字符，为字符分配8个单位宽度
                flexWidth += 10;
            }
        }
        if (str == 'consigneePhone') {
            flexWidth = flexWidth * 2;
        }
        if (flexWidth < 120) {
            // 设置最小宽度
            flexWidth = 120;
        }
        // if (flexWidth > 250) {
        //   // 设置最大宽度
        //   flexWidth = 250
        // }
        return flexWidth + 20 + 'px';
    }

      getStrWithSimonFromNum(num){
        let numstr = num.toString();
        let arr = numstr.split('.');
        if(arr.length>1){
            return  arr[0].toString().includes('-')?'-'+arr[0].toString().split('').reverse().join('').match(/\d{1,3}/g).join(',').split('').reverse().join('')+'.'+arr[1]:arr[0].toString().split('').reverse().join('').match(/\d{1,3}/g).join(',').split('').reverse().join('')+'.'+arr[1];
        }else{
            return  arr[0].toString().includes('-')?'-'+arr[0].toString().split('').reverse().join('').match(/\d{1,3}/g).join(',').split('').reverse().join(''):arr[0].toString().split('').reverse().join('').match(/\d{1,3}/g).join(',').split('').reverse().join('');
        }
    }

    qrzj(row, type) {
        //this.row1 = row.id
        
        let h = this.$createElement;
        this.$confirm('', {
            message: h('div', null, [
                h('span', { style: 'margin-left:10px;font-size:16px;line-height:30px;font-weight:600;vertical-align:top;' }, [
                    h('i', { class: 'iconfont icon-zhongjie1', style: 'color:#1cae7d;font-size:20px;margin-right:10px;' }),
                    h('span', null, '终结该运单'),
                ]),
                h('p', { style: 'margin:10px 0 0 40px;' }, [
                    h('span', null, '是否确认终结'),
                    
                    h('span', null, '该运单?'),
                ]),
            ]),
        })
            .then(() => {
                WayBill.endYd({ id: row.id }).then((res) => {
                    this.$message.success('运单终结成功!');
                    this.getInquiryList();
                });
            })
            .catch(() => {});
    }

    getShowData(data){
        let list = data.split(",");
        return list;
    }
    async querySearchAsynccc(queryString, cb) {
        var res = await yun.GetCarrierList({ name: queryString, count: 30 });
        var restaurants = [];
        if (res) {
            res.data.forEach((item) => {
                restaurants.push({
                    value: item.name,
                });
            });
            cb(restaurants);
        }
    }
    async querySearchAsyCustomerName(queryString, cb){
            let res = await yun.ShipperGetList({
                name: queryString,
                type: 1,
                count: 30,
            });
            let dds = [];
            if (res) {
                res.forEach((item) => {
                    dds.push({
                        id:item.id,
                        customerBaseCode: item.customerBaseCode,
                        value: item.customerBaseName,
                    });
                });
                cb(dds);
            }
    }

}
